import { render } from "./TradeCard.vue?vue&type=template&id=216431b2"
import script from "./TradeCard.vue?vue&type=script&lang=ts"
export * from "./TradeCard.vue?vue&type=script&lang=ts"
script.render = render

export default script